import { SoapUtils } from '../../../utils/SoapUtils';

export interface MessageTemplate {
    id?: string;
    aclh?: string;
    contextId?: string;
    treeHandle?: string;
    templateName?: string;
    description?: string;
    created?: string;
    subject?: string;
    recipient?: string;
    identity?: string;
    messageContainer?: string;
    messageContainerName?: string;
    messageGroup?: string;
    isDraft?: string;
    html?: string;
    type?: string;
    language?: string;
    isDefault?: string;
    folderId?: string;
    projectId?: string;
    activityId?: string;
    RECIPIENT?: Recipient;
    BODY?: BODYClass;
    NOTIFY?: BODYClass;
    DOCUMENTS?: Documents;
    TRANSLATIONS?: Translations;
    ADVERTISEMENT?: Advertisement;
    JOB_DESCRIPTION_ITEMS?: JobDescriptionItems;
  }
  
  export function toMessageTemplateXml(messageTemplate: MessageTemplate): string {
    let xml = '';
  
    xml += SoapUtils.makeNode(messageTemplate.id, 'id');
    xml += SoapUtils.makeNode(messageTemplate.aclh, 'aclh');
    xml += SoapUtils.makeNode(messageTemplate.contextId, 'contextId');
    xml += SoapUtils.makeNode(messageTemplate.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(messageTemplate.templateName, 'templateName');
    xml += SoapUtils.makeNode(messageTemplate.description, 'description');
    xml += SoapUtils.makeNode(messageTemplate.created, 'created');
    xml += SoapUtils.makeNode(messageTemplate.subject, 'subject');
    xml += SoapUtils.makeNode(messageTemplate.recipient, 'recipient');
    xml += SoapUtils.makeNode(messageTemplate.identity, 'identity');
    xml += SoapUtils.makeNode(messageTemplate.messageContainer, 'messageContainer');
    xml += SoapUtils.makeNode(messageTemplate.messageContainerName, 'messageContainerName');
    xml += SoapUtils.makeNode(messageTemplate.messageGroup, 'messageGroup');
    xml += SoapUtils.makeNode(messageTemplate.isDraft, 'isDraft');
    xml += SoapUtils.makeNode(messageTemplate.html, 'html');
    xml += SoapUtils.makeNode(messageTemplate.type, 'type');
    xml += SoapUtils.makeNode(messageTemplate.language, 'language');
    xml += SoapUtils.makeNode(messageTemplate.isDefault, 'isDefault');
    xml += SoapUtils.makeNode(messageTemplate.folderId, 'folderId');
    xml += SoapUtils.makeNode(messageTemplate.projectId, 'projectId');
    xml += SoapUtils.makeNode(messageTemplate.activityId, 'activityId');
    if (messageTemplate.RECIPIENT) xml += toRecipientXml(messageTemplate.RECIPIENT);
    if (messageTemplate.BODY) xml += toBODYClassXml(messageTemplate.BODY, 'BODY');
    if (messageTemplate.NOTIFY) xml += toBODYClassXml(messageTemplate.NOTIFY, 'NOTIFY');
    if (messageTemplate.DOCUMENTS) xml += toDocumentsXml(messageTemplate.DOCUMENTS);
    if (messageTemplate.TRANSLATIONS) xml += toTranslationsXml(messageTemplate.TRANSLATIONS);
    if (messageTemplate.ADVERTISEMENT) xml += toAdvertisementXml(messageTemplate.ADVERTISEMENT);
    if (messageTemplate.JOB_DESCRIPTION_ITEMS) xml += toJobDescriptionItemsXml(messageTemplate.JOB_DESCRIPTION_ITEMS);
  
    return `<messageTemplate>${xml}</messageTemplate>`;
  }
  
  export interface Advertisement {
    jobDescription?: string;
    requirements?: string;
    offer?: string;
    clientInfo?: string;
    footer?: string;
    contactName?: string;
    contactPhone?: string;
    contactMail?: string;
    priority?: string;
    salaryCurrency?: string;
    salaryMin?: string;
    salaryMax?: string;
    salaryText?: string;
    KEYWORDS?: Keywords;
  }
  
  function toAdvertisementXml(advertisement: Advertisement): string {
    let xml = '';
    xml += SoapUtils.makeNode(advertisement.jobDescription, 'jobDescription');
    xml += SoapUtils.makeNode(advertisement.requirements, 'requirements');
    xml += SoapUtils.makeNode(advertisement.offer, 'offer');
    xml += SoapUtils.makeNode(advertisement.clientInfo, 'clientInfo');
    xml += SoapUtils.makeNode(advertisement.footer, 'footer');
    xml += SoapUtils.makeNode(advertisement.contactName, 'contactName');
    xml += SoapUtils.makeNode(advertisement.contactPhone, 'contactPhone');
    xml += SoapUtils.makeNode(advertisement.contactMail, 'contactMail');
    xml += SoapUtils.makeNode(advertisement.priority, 'priority');
    xml += SoapUtils.makeNode(advertisement.salaryCurrency, 'salaryCurrency');
    xml += SoapUtils.makeNode(advertisement.salaryMin, 'salaryMin');
    xml += SoapUtils.makeNode(advertisement.salaryMax, 'salaryMax');
    xml += SoapUtils.makeNode(advertisement.salaryText, 'salaryText');
    if (advertisement.KEYWORDS) xml += toKeywordsXml(advertisement.KEYWORDS);
  
    return `<ADVERTISEMENT>${xml}</ADVERTISEMENT>`;
  }
  
  export interface Keywords {
    ROW: KeywordsRow[];
  }
  
  function toKeywordsXml(keywords: Keywords): string {
    let xml = '';
    keywords.ROW.forEach(keyword => {
      xml += toKeywordsRowXml(keyword);
    });
    return `<KEYWORDS>${xml}</KEYWORDS>`;
  }
  
  export interface KeywordsRow {
    keyword: string;
  }
  
  function toKeywordsRowXml(keyword: KeywordsRow): string {
    let xml = '';
    xml += SoapUtils.makeNode(keyword.keyword, 'keyword');
    return `<ROW>${xml}</ROW>`;
  }
  
  export interface BODYClass {
    string: string;
  }
  
  function toBODYClassXml(bodyClass: BODYClass, type: string): string {
    let xml = '';
    xml += SoapUtils.makeNode(bodyClass.string, 'string');
    return `<${type}>${xml}</${type}>`;
  }
  
  export interface Documents {
    DOCUMENT: Document[];
  }
  
  function toDocumentsXml(documents: Documents): string {
    let xml = '';
    documents.DOCUMENT.forEach(document => {
      xml += toDocumentXml(document);
    });
    return `<DOCUMENTS>${xml}</DOCUMENTS>`;
  }
  
  export interface Document {
    id: string;
    name?: string;
    size?: string;
  }
  
  function toDocumentXml(document: Document): string {
    let xml = '';
    xml += SoapUtils.makeNode(document.id, 'id');
    xml += SoapUtils.makeNode(document.name, 'name');
    xml += SoapUtils.makeNode(document.size, 'size');
    return `<DOCUMENT>${xml}</DOCUMENT>`;
  }
  export interface JobDescriptionItems {
    ROW: JobDescriptionItemsRow[];
  }
  
  function toJobDescriptionItemsXml(jobDescriptionItems: JobDescriptionItems): string {
    let xml = '';
    jobDescriptionItems.ROW.forEach(item => {
      xml += toJobDescriptionItemsRowXml(item);
    });
    return `<JOB_DESCRIPTION_ITEMS>${xml}</JOB_DESCRIPTION_ITEMS>`;
  }
  
  export interface JobDescriptionItemsRow {
    id?: string;
    type?: string;
    valueId?: string;
    value?: string;
    parent?: string;
  }
  
  function toJobDescriptionItemsRowXml(item: JobDescriptionItemsRow): string {
    let xml = '';
    xml += SoapUtils.makeNode(item.id, 'id');
    xml += SoapUtils.makeNode(item.type, 'type');
    xml += SoapUtils.makeNode(item.valueId, 'valueId');
    return `<ROW>${xml}</ROW>`;
  }
  
  export interface Recipient {
    TO?: ContactInfo[];
    CC?: ContactInfo[];
    BCC?: ContactInfo[];
    USER?: ContactInfo[];
  }
  
  function toRecipientXml(recipient: Recipient): string {
    let xml = '';
    if (recipient.TO)
      recipient.TO.forEach(contact => {
        xml += toContactInfoXml(contact, 'TO');
      });
    if (recipient.CC)
      recipient.CC.forEach(contact => {
        xml += toContactInfoXml(contact, 'CC');
      });
    if (recipient.BCC)
      recipient.BCC.forEach(contact => {
        xml += toContactInfoXml(contact, 'BCC');
      });
    if (recipient.USER)
      recipient.USER.forEach(contact => {
        xml += toContactInfoXml(contact, 'USER');
      });
    return `<RECIPIENT>${xml}</RECIPIENT>`;
  }
  
  export interface ContactInfo {
    CONTENT?: string;
    salutation?: string;
    contactName?: string;
    id?: string;
  }
  
  function toContactInfoXml(contact: ContactInfo, type: string): string {
    let xml = '';
    xml += SoapUtils.makeNode(contact.CONTENT, 'CONTENT');
    xml += SoapUtils.makeNode(contact.salutation, 'salutation');
    xml += SoapUtils.makeNode(contact.contactName, 'contact');
    xml += SoapUtils.makeNode(contact.id, 'id');
    return `<${type}>${xml}</${type}>`;
  }
  
  export interface Translations {
    TRANSLATION: Translation[];
  }
  
  function toTranslationsXml(translations: Translations): string {
    let xml = '';
    translations.TRANSLATION.forEach(translation => {
      xml += toTranslationXml(translation);
    });
    return `<TRANSLATIONS>${xml}</TRANSLATIONS>`;
  }
  export interface Translation {
    id?: string;
    name?: string;
    isDefault?: string;
    language?: string;
  }
  
  function toTranslationXml(translation: Translation): string {
    let xml = '';
    xml += SoapUtils.makeNode(translation.id, 'id');
    xml += SoapUtils.makeNode(translation.name, 'name');
    xml += SoapUtils.makeNode(translation.isDefault, 'isDefault');
    xml += SoapUtils.makeNode(translation.language, 'language');
    return `<TRANSLATION>${xml}</TRANSLATION>`;
  }
  